module.exports = __webpack_public_path__ + "static/media/parallax-bg11.52814f2d.jpg";